var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.products, function (item, key) {
      return _c(
        "div",
        { key: key, staticClass: "cart-item" },
        [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col-12 col-md-8" }, [
              item.type == "toll"
                ? _c("span", { staticClass: "category" }, [
                    _vm._v(
                      _vm._s(_vm.capitalize(_vm.$tc("tollWord", 0))) +
                        ", " +
                        _vm._s(_vm.$tc("my_orders_passings", item.quantity))
                    ),
                  ])
                : _vm._e(),
              item.type == "vignette"
                ? _c("span", { staticClass: "category" }, [
                    _vm._v(
                      _vm._s(_vm.capitalize(_vm.$tc("vignetteWord", 1))) +
                        ", " +
                        _vm._s(
                          _vm.$tc(
                            item.days == 12 ? "months" : "days",
                            item.days
                          )
                        )
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "col-12 col-md-4 text-md-right" }, [
              _c("p", { staticClass: "f-style m-md-0" }, [
                _vm._v(
                  _vm._s(item.price) +
                    " " +
                    _vm._s(_vm.$tc("currency", item.price))
                ),
              ]),
            ]),
          ]),
          item.type == "vignette"
            ? [
                _c("div", { staticClass: "row mt-md-2" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("span", { staticClass: "ancillary" }, [
                      _vm._v(
                        _vm._s(_vm.capitalize(_vm.$t("cart_available_from")))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-md-6 text-md-right" }, [
                    _c("p", { staticClass: "f-style" }, [
                      _vm._v(_vm._s(_vm.formatDate(item.fromDate))),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
          item.chasisNo
            ? [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("span", { staticClass: "ancillary" }, [
                      _vm._v(_vm._s(_vm.$t("label_chasis_number"))),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-md-6 text-md-right" }, [
                    _c("p", { staticClass: "f-style" }, [
                      _vm._v(_vm._s(item.chasisNo)),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("span", { staticClass: "ancillary" }, [
                _vm._v(_vm._s(_vm.$t("label_license_plate"))),
              ]),
            ]),
            _c("div", { staticClass: "col-md-6 text-md-right" }, [
              _c("p", { staticClass: "f-style" }, [
                _vm._v(_vm._s(item.plateNo)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("span", { staticClass: "ancillary" }, [
                _vm._v(_vm._s(item.category_name)),
              ]),
            ]),
            _c("div", { staticClass: "col-md-6 text-md-right" }, [
              _c("p", {
                staticClass: "f-style",
                domProps: { innerHTML: _vm._s(item.category_description) },
              }),
            ]),
          ]),
          item.type == "toll"
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c("span", { staticClass: "ancillary" }, [
                    _vm._v(
                      _vm._s(_vm.capitalize(_vm.$tc("passing", item.quantity)))
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col-md-6 text-md-right" }, [
                  _c("p", {
                    staticClass: "f-style",
                    domProps: { innerHTML: _vm._s(item.quantity) },
                  }),
                ]),
              ])
            : _vm._e(),
          item.sms_confirm_notification && _vm.getSmsSetting != null
            ? _c("span", { staticClass: "ancillary d-block" }, [
                _c("span", { staticClass: "far fa-envelope" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$tc(
                        "sms_notification_confirmation",
                        Math.ceil(_vm.getSmsSetting.value),
                        { price: _vm.getSmsSettingMessage() }
                      )
                    )
                ),
              ])
            : _vm._e(),
          item.sms_expiry_notification && _vm.getSmsSetting != null
            ? _c("span", { staticClass: "ancillary d-block" }, [
                _c("span", { staticClass: "far fa-envelope" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$tc(
                        "sms_notification_expiry",
                        Math.ceil(_vm.getSmsSetting.value),
                        { price: _vm.getSmsSettingMessage() }
                      )
                    )
                ),
              ])
            : _vm._e(),
          item.cnair_expiry_notification
            ? _c("span", { staticClass: "ancillary d-block" }, [
                _c("span", { staticClass: "far fa-envelope" }),
                _vm._v(" " + _vm._s(_vm.$t("cnair_notification_expiry"))),
              ])
            : _vm._e(),
          _vm.showDeleteBtn
            ? _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
                !item.transaction_errors
                  ? _c(
                      "div",
                      {
                        staticClass: "mr-md-5 mr-3",
                        on: {
                          click: function ($event) {
                            return _vm.editItem(key)
                          },
                        },
                      },
                      [_vm._m(0, true)]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.removeItem(key)
                      },
                    },
                  },
                  [_vm._m(1, true)]
                ),
              ])
            : _vm._e(),
          item.transaction_errors
            ? _vm._l(item.transaction_errors, function (err, key) {
                return _c(
                  "span",
                  { key: key, staticClass: "f-style text-danger text-break" },
                  [_c("b", [_vm._v(_vm._s(err))])]
                )
              })
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon edit-icon" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon delete-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }